import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@avangard/ui/core';

import type { DialogProps } from '@avangard/ui/core';

export type DialogRemoveLapAccessProps = Pick<
    DialogProps,
    'open' | 'onClose' | 'disabled' | 'onCancel' | 'onAccept'
>;

const DialogRemoveLapAccess = (props: DialogRemoveLapAccessProps): React.ReactElement => {
    const { t } = useTranslation(['common', 'access']);

    return (
        <Dialog
            title={t('access:remove_access.confirm')}
            cancelText={t('common:actions.cancel') ?? ''}
            acceptText={t('common:actions.remove') ?? ''}
            {...props}
        />
    );
};

export { DialogRemoveLapAccess };
